import React from "react";
import { useSelector, useDispatch } from "react-redux";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import Dropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { changeCategory } from "../redux/customChartSagas";

const CategoryDropdown = ({ categoryKey, name, targetKey }) => {
  const dispatch = useDispatch();
  const categoryOptions = useSelector((state) => state.customCharts.categories);
  const isCategoriesLoading = useSelector((state) => state.customCharts.isCategoriesLoading);
  const selectedCategories = useSelector(
    (state) => state.customCharts.previewModalData.selectedCategories
  );
  const showClearButton =
    categoryKey === "compare_category" && selectedCategories?.compare_category;

  return (
    <>
      {name && <p>{name}</p>}
      {isCategoriesLoading ? (
        <LoadingAnimation uiLoader />
      ) : (
        <Dropdown
          height={275}
          haveOnSelectChange
          placeholder="Select an option"
          options={categoryOptions}
          keepOpen={false}
          multiple={false}
          selectedFilters={selectedCategories[categoryKey]}
          onSelectChange={(data) => {
            dispatch(changeCategory({ [categoryKey]: data }));
          }}
          numberDisplayed={0}
        />
      )}
      {showClearButton && (
        <span
          className="clear-dropdown-button"
          onClick={() => dispatch(changeCategory({ compare_category: null }))}
        >
          x
        </span>
      )}

      {selectedCategories[categoryKey]?.targets && (
        <Dropdown
          height={275}
          haveOnSelectChange
          placeholder="Select an option"
          options={selectedCategories[categoryKey]?.targets}
          keepOpen={false}
          multiple={false}
          selectedFilters={
            selectedCategories[targetKey] || selectedCategories[categoryKey]?.targets[0]
          }
          onSelectChange={(data) => dispatch(changeCategory({ [targetKey]: data }))}
          numberDisplayed={0}
        />
      )}
    </>
  );
};

export default CategoryDropdown;
